<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />
    <div
      class="bg-white d-flex align-items-center justify-content-center px-2 py-4 p-lg-5 border border-2 border-azul-claro2 mx-3"
    >
      <div class="text-center">
        <FontAwesomeIcon icon="times-circle" class="fa-3x text-danger" />
        <div class="h3 text-danger font-weight-bold mt-4">
          Error 404: URL Incorrecta
        </div>
        <div class="d-block mt-4 font-weight-bold text-secondary">
          La dirección URL a la que intenta acceder es incorrecta
          <router-link
            tag="button"
            :to="{ name: 'Sae' }"
            class="btn btn-lg btn-azul-oscuro2 d-block mt-1 px-auto px-lg-4 gilmer text-uppercase"
            >Sistema de Admisión Escolar</router-link
          >
        </div>
      </div>
    </div>
    <!--
    <router-link
      tag="button"
      variant="success"
      :to="{ name: 'Validar', query:{'postulacion': param} }"
    >Probar</router-link>

    -->
    <router-link
      v-if="!isPorduccion"
      tag="button"
      variant="success"
      :to="{ name: 'DescargarResultado', query: { resultado: param } }"
      >Probar Resultados</router-link
    >
    <router-link
      v-if="!isPorduccion"
      tag="button"
      variant="success"
      :to="{ name: 'DescargarComprobante', query: { postulacion: param } }"
      >Probar Postulacion</router-link
    >
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Titulo from "@/components/generales/Titulo";
library.add(faTimesCircle);
export default {
  components: {
    Titulo,
    FontAwesomeIcon
  },
  data() {
    return {
      param:
        "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNTkxNjU1MjUzLCJleHAiOjE2MjMxOTEyNTMsImlkUG9zdHVsYWNpb24iOiI1ZWRlYmIzMGYzOTUzNTAwMDE5ZGE3NzIiLCJpc0FkbWluIjpmYWxzZX0.SWMiYFecnbgAo9Q8-xsDWNmNJBBGSWTU6O7dpnqW7C4"
    };
  },
  computed: {
    isPorduccion() {
      return process.env.NODE_ENV === "production";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Inicio.vue